import context from '@/providers/context'
import * as routing from '@/providers/routing'

import {WithProps as WizardFactory} from '@/helpers/components/display/Wizard'

// lazy component loading with webpack
//const Wizard = () => import(/* webpackChunkName: "billing" */ './Wizard.vue');
//wizard's subcomponents
//const WizardChoose = () => import(/* webpackChunkName: "billing" */ './wizard/Choose.vue');
const WizardSubscribe = () => import(/* webpackChunkName: "billing" */ './wizard/Subscribe.vue');

const Overview = () => import(/* webpackChunkName: "billing" */ './Overview.vue');
const Invoice = () => import(/* webpackChunkName: "billing" */ './Invoice.vue');
const Transactions = () => import(/* webpackChunkName: "billing" */ './Transactions.vue');

export const routes = [
  {
    path: '/billings',
    name: 'billings',
    component: Overview,
    meta: {
      trans: 'titles.plan_billings',
      icon: 'dollar',
    },
    children: [
      {
        path: 'new',
        component: WizardFactory(['plans', 'current']),
        children: [
          {
            path: '',
            name: 'billings.new',
            component: WizardSubscribe,
            meta: {priority: 20,},
          },
          {
            path: ':plan_id',
            name: 'billings.new.subscribe',
            component: WizardSubscribe,
            meta: {priority: 21,},
            props: true,
          }
        ],
      },
      {
        path: 'invoices/:id/transactions',
        name: 'billings.invoices.transactions',
        component: Transactions,
        props: true,
      },
      {
        path: 'invoices/:id',
        name: 'billings.invoices.show',
        component: Invoice,
        props: true,
      },
    ],
  },
];

export function guard(router) {
  router.beforeResolve((to, from, next) => {
    context.getters.async(['user', 'billing_plan']).then(([user, billing_plan]) => {
      if (!billing_plan.length && !context.getters.admin) {
        console.log('Guard: Company has no billing plan and must create one.');
        return routing.priorityNext(to, {name: 'billings.new'}, next, router);
      }
      return next();
    }).catch(() => next());
  });
}


// TRANSLATIONS
import en from './i18n/en'
import it from './i18n/it'
import sl from './i18n/sl'
import de from './i18n/de'
import fr from './i18n/fr'
import i18n from '@/providers/i18n'

for (let [lang, bundle] of Object.entries({en, it, sl, de, fr})) {
  i18n.i18next.addResourceBundle(lang, 'billings', bundle);
}


// WEBPACK FOOTER //
// ./src/sections/billings/index.js